// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__POOtA","choiceBoxes":"toolbarselects_choiceBoxes__2b3bm","simpleField":"toolbarselects_simpleField__2FFCW"};